import React, { Component } from "react";
import { withApollo } from "react-apollo";
import gql from "graphql-tag";
import Link from "./Link";
import { USER_ID } from "../constants";

const FEED_SEARCH_QUERY = gql`
  query FeedSearchQuery($filter: String!, $orderBy: LinkOrderByInput) {
    feed(filter: $filter, orderBy: $orderBy) {
      links {
        id
        created
        url
        description
        ranking
        postedBy {
          id
          name
        }
        votes {
          id
          user {
            id
          }
        }
        comments {
          id
        }
      }
    }
  }
`;

class Search extends Component {
  state = {
    links: [],
    filter: "",
    hasSearched: false,
  };

  _updateCacheAfterVote = (store, voteData, linkId) => {
    const orderBy = "ranking_DESC";
    const data = store.readQuery({
      query: FEED_SEARCH_QUERY,
      variables: { filter: this.state.filter, orderBy },
    });

    const link = data.feed.links.find((link) => link.id === linkId);
    link.votes = voteData.vote
      ? voteData.vote.link.votes
      : link.votes.filter((vote) => {
        return vote.id !== voteData.unvote.id;
      });
    store.writeQuery({
      query: FEED_SEARCH_QUERY,
      data,
      variables: { filter: this.state.filter, orderBy },
    });
    this.setState({
      links: data.feed.links,
    });
  };

  render() {
    return (
      <div>
        <div className="mt2 mb3">
          Search
          <input
            type="text"
            className="ml2 mr2"
            onChange={(e) => this.setState({ filter: e.target.value })}
            onKeyPress={(e) => {
              if (e.key === "Enter") {
                this._executeSearch();
              }
            }}
          />
          <button
            className="pointer button"
            onClick={() => this._executeSearch()}
          >
            OK
          </button>
        </div>
        {this.state.hasSearched && this.state.links.length === 0 ? "No matches" : this.state.links.map((link, index) => (
          <Link
            key={link.id}
            link={link}
            index={index}
            updateStoreAfterVote={this._updateCacheAfterVote}
            votable={
              link.postedBy
                ? localStorage.getItem(USER_ID) !== link.postedBy.id
                : true
            }
          />
        ))}
      </div>
    );
  }

  _executeSearch = async () => {
    const { filter } = this.state;
    const result = await this.props.client.query({
      query: FEED_SEARCH_QUERY,
      variables: { filter, orderBy: "ranking_DESC" },
    });
    const links = result.data.feed.links;
    this.setState({ links, hasSearched: true });
  };
}

export default withApollo(Search);



// WEBPACK FOOTER //
// ./src/components/Search.js